import { useEffect } from 'react';
import { useLoginInfo } from '@yaotai/common-utils';

export const useLoginNoAuthRedirect = ({ noAuthRedirectUrl }: { noAuthRedirectUrl: string }) => {
  const { noAuth, handleLogOut } = useLoginInfo();

  useEffect(() => {
    if (noAuth) {
      handleLogOut();
      window.location.href = noAuthRedirectUrl;
    }
    return () => {};
  }, [noAuth, noAuthRedirectUrl]);
};
